import React, { useContext } from "react";
import { formatAppDate } from "../../helpers/date-formatter";
import { TicketIcon } from "@heroicons/react/16/solid";
import { Link } from "react-router-dom";
import DataTable from "../table/DataTable";
import { InitialsAvatar, TextStack } from "../table/DataTableCell";
import StatusBadge from "../table/StatusBadge";
import ActionGroup, { ActionButton } from "../table/ActionGroup";
import AuthContext from "../../context/auth/AuthContext";
import { TENANT_MODULES } from "../../helpers/tenant-modules";

const formatMemberSince = (date) => {
  if (!date) {
    return "";
  }

  return `Member since ${formatAppDate(date)}`;
};

function UsersTable({ users }) {
  const { isModuleEnabled } = useContext(AuthContext);
  const campaignsEnabled = isModuleEnabled?.(TENANT_MODULES.CAMPAIGNS);

  const columns = [
    {
      key: "user",
      label: "User Name",
      render: (user) => {
        const { firstName, lastName, registeredOn } = user.userInfo ?? {};
        const fullName = [firstName, lastName].filter(Boolean).join(" ");

        return (
          <div className="flex items-center gap-4">
            <InitialsAvatar name={fullName || user.username} fallback="U" />
            <Link to={`/users/${user.id}`} className="hover:text-icon-blue">
              <TextStack
                primary={fullName || user.username}
                secondary={formatMemberSince(registeredOn)}
              />
            </Link>
          </div>
        );
      },
    },
    {
      key: "email",
      label: "Email",
      render: (user) => user.userInfo?.email || user.username || "-",
    },
    {
      key: "status",
      label: "Status",
      width: "180px",
      render: (user) => (
        <StatusBadge active={user.enabled !== false} label={user.enabled === false ? "Inactive" : "Active"} />
      ),
    },
    ...(campaignsEnabled
      ? [
          {
            key: "actions",
            label: "Actions",
            align: "right",
            width: "140px",
            render: (user) => (
              <ActionGroup>
                <ActionButton
                  as={Link}
                  to={`/users/${user.id}/coupons`}
                  color="green"
                  title="Coupons"
                >
                  <TicketIcon className="h-5 w-5" />
                </ActionButton>
              </ActionGroup>
            ),
          },
        ]
      : []),
  ];

  return (
    <DataTable
      columns={columns}
      rows={users}
      rowKey="id"
      minWidth="760px"
      emptyMessage="No users found."
    />
  );
}

export default UsersTable;
